function getValueTransition(transition, key) {
    return (transition[key] ||
        transition["default"] ||
        transition);
}

export { getValueTransition };
